(function importerControllerDefinition() {
    'use strict';

    angular.module('Importer')
        .controller('ImporterAddController', [
                '$scope', 'config', '$state', 'errorsExtend', '$stateParams', 'importerService', 'authExtend',
                function importerController($scope, config, $state, errorsExtend, $stateParams,  importerService, authExtend) {
                    $scope.importer =
                        {
                        };
                    $scope.aux =
                        {
                            files: [],
                            filesTemp: []
                        };

                    $scope.addFile = function () {

                        $scope.aux.filesTemp.forEach(function (file) {

                            if (file && file.size) {

                                if ( (/\.((mdb))$/i).test(file.name) ) {

                                    var index = $scope.getIndexFile(file);

                                    if (~index)
                                    {
                                        $scope.aux.files[index] = file;
                                    }
                                    else
                                    {
                                        $scope.aux.files = [];
                                        $scope.aux.files.push(file);
                                    }
                                }
                                else
                                {
                                    errorsExtend.showError('You_must_select_an Access_file');
                                }
                            }
                        });

                        $scope.aux.filesTemp = [];
                    }

                    $scope.getIndexFile = function (fileNew) {
                        for (var i in $scope.aux.files) {
                            if ($scope.aux.files.hasOwnProperty(i)) {
                                var fileOld = $scope.aux.files[i];

                                if (fileOld.name === fileNew.name) {
                                    return i;
                                }
                            }
                        };

                        return -1;
                    }

                    $scope.save = function () {
                        var msj = '';
                        if (!$scope.importerForm.$valid) {
                            $scope.importerForm.$setSubmitted();
                            msj = 'VerifyFormData';
                        }

                        if ($scope.aux.files.length <= 0) {
                            msj += 'VerifyFormFile';
                        }

                        if (msj !== '') {
                            errorsExtend.showError(msj);
                            return;
                        }
                        return importerService.create($scope.aux.files).then(function () {
                            $state.go('inicio');
                        }, function (error) {
                            errorsExtend.showError(error);
                        });
                    };

                    $scope.cancel = function () {
                        $state.go('inicio');
                    };

                    $scope.removeFile = function (file) {
                        var index = $scope.getIndexFile(file);

                        if (~index) {
                            $scope.aux.files.splice(index, 1);
                        }
                    }
                }
        ]);
})();